import React, { useState } from 'react';
import NavLink from './VerticalNavigation';
import style from 'assets/scss/nav.module.css';
import { ReactComponent as BrandLogo} from 'assets/img/love-little-dragons-logo.svg';

const navLinks = [
    {navLinkId: 'Philosophy', scrollToId: 'philosophy'},
    {navLinkId: 'Tribes', scrollToId: 'tribes'},
    {navLinkId: 'Donate', scrollToId: 'donate'},
];

export default function PrimaryNavigation() {
    const [activeNavLinkId, setActiveNavLinkId] = useState('');
    
    return (
        <header className={style.__header}>
            <div className={`${style.__headerWrapper} sm:gap-10 gap-5 sm:justify-start py-10`}>
                <div className={style.__brand}>
                    <BrandLogo className="sm:max-w-[80px] max-w-[50px] sm:max-h-[80px] max-h-[50px]" />
                </div>
                <nav className={`${style.__nav} py-4 flex sm:gap-10 gap-5 justify-left items-center sm:ml-0 ml-auto`}>
                    { navLinks.map(
                        ({navLinkId, scrollToId}) =>
                        <NavLink
                            key={navLinkId}
                            navLinkId={navLinkId} 
                            scrollToId={scrollToId} 
                            activeNavLinkId={activeNavLinkId}
                            setActiveNavLinkId={setActiveNavLinkId} 
                        />
                    )}
                </nav>
            </div>
        </header>
    )
}